/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ counted: NonNullable<unknown>, total: NonNullable<unknown> }} Nutrition_CoverageInputs */

const en_nutrition_coverage = /** @type {(inputs: Nutrition_CoverageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Computed from ${i?.counted} of ${i?.total} ingredients`)
};

const de_nutrition_coverage = /** @type {(inputs: Nutrition_CoverageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Berechnet aus ${i?.counted} von ${i?.total} Zutaten`)
};

/**
* | output |
* | --- |
* | "Computed from {counted} of {total} ingredients" |
*
* @param {Nutrition_CoverageInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const nutrition_coverage = /** @type {((inputs: Nutrition_CoverageInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nutrition_CoverageInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_nutrition_coverage(inputs)
	return en_nutrition_coverage(inputs)
});